import React, { Component } from "react";
import { Button, Icon, Pagination } from "semantic-ui-react";
import "./styles.scss";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { compose } from "redux";
import PositionForm from "../../components/PositionForm";
import {
    getPositionList,
    addPosition,
    updatePosition,
    deletePosition
} from "../../core/actions/positionAction";
import { exportFileAction } from "../../core/actions/commonAction";
import ProjectTable from "../../components/ProjectTable";
import CONSTANT from "../../core/constant/constant";

class Position extends Component {
    constructor() {
        super();
        this.state = {
            tableStructure: [
                {
                    label: "labels.id",
                    type: "id",
                    isClass: "first-col"
                },
                {
                    label: "labels.positionCode",
                    type: "positionCode",
                    isClass: "second-col",
                    sort: true
                },
                {
                    label: "labels.description",
                    type: "positionName",
                    isClass: "last-col",
                    sort: true
                }
            ],
            paramList: {
                isSearch: 0,
                positionCode: "",
                positionName: "",
                currentPage: "",
                pageRecord: CONSTANT.pageRecord,
                sortBy: "positionCode-ASC"
            },
            position: {
                positionCode: "",
                positionName: ""
            },
            inputSubmit: {
                isSubmit: false,
                formError: {}
            },
            data: "",
            totalPage: 0,
            activePage: 1,
            disabled: true,
            errorCode: "",
            successCode: "",
            unSelectRow: false,
            isSearch: 0,
            btnDisable: false,
            exportDisabled: false,
            rowId: "",
            isAdded: false
        };
    }

    componentWillMount() {
        // Call API position-list, show list position
        this.props.getPositionList(this.state.paramList);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.positionReducer.isLoading) {
            this.clearPosition();
            if (this.state.isAdded === true) {
                this.getList();
            } else {
                this.props.getPositionList(this.state.paramList);
            }
        } else {
            let data = nextProps.positionReducer.dataPosition.positionList;
            this.setState({
                data: data,
                totalPage: nextProps.positionReducer.dataPosition.totalPage,
                activePage: nextProps.positionReducer.dataPosition.currentPage || 1,
                btnDisable: false
            });

            // No data
            if (!data || (data && !data[0])) {
                this.setState({
                    errorCode: "018",
                    exportDisabled: true
                });
                setTimeout(
                    function () {
                        this.setState({ errorCode: "" });
                        nextProps.positionReducer.errorCode = "";
                    }.bind(this),
                    2000
                );

            } else {
                this.setState({
                    exportDisabled: false
                });
            }

            // Data have success code
            if (nextProps.positionReducer.successCode) {
                this.setState({
                    successCode: nextProps.positionReducer.successCode,
                });
                if (this.state.isAdded === true) {
                    this.clearParamList(false);
                }
                setTimeout(
                    function () {
                        this.setState({ successCode: "" });
                        nextProps.positionReducer.successCode = ""
                    }.bind(this),
                    2000
                );
            }

            if (nextProps.positionReducer.errorCode) {
                this.setState({
                    errorCode: nextProps.positionReducer.errorCode,
                });
                setTimeout(
                    function () {
                        this.setState({ errorCode: "" });
                        nextProps.positionReducer.errorCode = "";
                    }.bind(this),
                    2000
                );
            }

        }
    }

    async getList() {
        let clrParam = await this.clearParamList(false);
        return this.props.getPositionList(this.state.paramList);       
    }

    // Event when click btn Search
    async searchPosition() {
        this.clearError();
        this.setState({ btnDisable: true });
        const positionCode = this.state.position.positionCode;
        const positionName = this.state.position.positionName;

        await this.setState({
            paramList: {
                isSearch: 1,
                positionCode: positionCode,
                positionName: positionName,
                currentPage: 1,
                pageRecord: CONSTANT.pageRecord,
                sortBy: this.state.paramList.sortBy
            },
            disabled: true,
            unSelectRow: false,
            isSearch: 1,
            activePage: 1
        });

        return this.props.getPositionList(this.state.paramList);
    }

    // Event when click btn Add
    addPosition = () => {
        if (!this.checkValidate()) return;
        
        this.setState({ btnDisable: true });
        const positionCode = this.state.position.positionCode;
        const positionName = this.state.position.positionName;

        this.setState({isAdded: true});
        return this.props.addPosition({
            positionCode: positionCode,
            positionName: positionName
        });
    }

    // Event when click btn Update 
    updatePosition = () => {
        if (!this.checkValidate()) return;
        this.setState({ btnDisable: true });
        const id = this.state.rowId;
        const positionCode = this.state.position.positionCode;
        const positionName = this.state.position.positionName;
        this.setState({isAdded: false});
        return this.props.updatePosition({
            id: id,
            positionCode: positionCode,
            positionName: positionName
        });

    }

    // Delete position
    deletePosition = async () => {
        this.setState({ btnDisable: true });
        const id = this.state.rowId;
        this.clearPosition();
        
        if (this.state.data.length === 1) {
            this.setState(prevState => ({
                paramList: {
                    ...prevState.paramList,
                    currentPage: 1
                }
            }));
        }
        this.setState({isAdded: false});
        return this.props.deletePosition({ id: id });
    }

    // Event when click btn Export
    positionExportAction = () => {
        this.clearError();
        const exportParam = {
            positionCode: this.state.paramList.positionCode,
            positionName: this.state.paramList.positionName,
            sortBy: this.state.paramList.sortBy
        };
        this.props.exportFileAction(
            {
                urlGetkey: "Position/requestSecretKey",
                urlDownfile: "Position/positionExport"
            },
            exportParam
        );
    }

    // Event when click clear position
    clearPosition = () => {
        this.setState({
            position: {
                positionCode: "",
                positionName: ""
            },
            disabled: true,
            unSelectRow: false,
            rowId: "",
            inputSubmit: {
                isSubmit: false,
                formError: {}
            },
        });
    }

    // Clear input error text
    clearError = () => {
        this.setState({
            inputSubmit: {
                isSubmit: false,
                formError: {}
            },
        });
    }

    // Clear param list call API
    clearParamList = (isSort) => {

        this.setState({
            paramList: {
                isSearch: 0,
                positionCode: "",
                positionName: "",
                currentPage: "",
                pageRecord: CONSTANT.pageRecord,
                sortBy: (isSort !== true) ? "positionCode-ASC" : this.state.paramList.sortBy
            },
        });
    }

    // Handle on change input
    changePosition = evt => {
        const name = evt.target.name;
        const value = evt.target.value;
        this.setState(prevState => ({
            position: {
                ...prevState.position,
                [name]: value
            }
        }));
        this.setState(prevState => ({
            inputSubmit: {
                ...prevState.inputSubmit,
                formError: {
                    ...prevState.inputSubmit.formError,
                    [name]: ''
                }
            }
        }));
        
    }

    // Event when click table row
    onRowClick = val => {
        this.clearError();
        let _position = {
            positionCode: val.positionCode !== null ? val.positionCode : "",
            positionName: val.positionName !== null ? val.positionName : ""
        };
        this.setState({
            disabled: false,
            position: _position,
            unSelectRow: true,
            rowId: val.id
        });
    }

    // Event when click sort table
    sortBy = async val => {
        await this.setState(prevState => ({
            paramList: {
                ...prevState.paramList,
                sortBy: val,
                rowId: val.id
            }
        }));
        this.props.getPositionList(this.state.paramList);
    }

    // Event when click btn pagination
    async handlePaginationChange(val) {
        await this.setState({
            activePage: val,
            paramList: {
                isSearch: this.state.isSearch,
                positionCode: this.state.paramList.positionCode,
                positionName: this.state.paramList.positionName,
                currentPage: val,
                pageRecord: CONSTANT.pageRecord,
                sortBy: this.state.paramList.sortBy
            }
        });

        return this.props.getPositionList(this.state.paramList);
    }

    // Check validate form
    checkValidate = () => {
        let isValidate = false;
        let _formError = {};

        (this.state.position.positionCode.trim() === '') ? _formError['positionCode'] = 'message.013' : _formError['positionCode'] = '';

        (this.state.position.positionName.trim() === '') ? _formError['positionName'] = 'message.014' : _formError['positionName'] = '';

        if (this.state.position.positionCode.trim() !== '' && this.state.position.positionName.trim() !== '') {
            isValidate = true;
            this.setState(prevState => ({
                inputSubmit: {
                    ...prevState.inputSubmit,
                    formError: {}
                }
            }));
        } else {
            isValidate = false;
            this.setState(prevState => ({
                inputSubmit: {
                    ...prevState.inputSubmit,
                    formError: _formError
                }
            }));
        }
        return isValidate;
    }

    render() {
        const { t } = this.props;
        const { activePage, errorCode, successCode, btnDisable} = this.state;
        return (
            <div>
                <h2 className="page-heading">
                    <span onClick={() => setTimeout(function() { window.location = "/employee" }, 500)}>
                        {t("navigation.master")}
                    </span>
                    /{" "}
                    <span onClick={() => setTimeout(function() { window.location = "/employee" }, 500)}>
                        {t("navigation.employee")}
                    </span>
                    /{" "}
                    <span onClick={() => setTimeout(function() { window.location.reload() }, 500)}>
                        {t("navigation.position")}
                    </span>
                </h2>
                <div className="list-actions">
                    <Button
                        primary
                        disabled={btnDisable}
                        onClick={() => this.searchPosition()}
                    >
                        <Icon name="search" />
                        {t("button.search")}
                    </Button>
                    <Button
                        primary
                        disabled={btnDisable}
                        onClick={() => this.addPosition()}
                    >
                        <Icon name="add circle" />
                        {t("button.add")}
                    </Button>
                    <Button 
                    primary 
                    disabled={this.state.disabled} 
                    className="update-btn"
                    onClick={() => this.updatePosition()}
                    >
                        <Icon name="edit" />
                        {t("button.update")}
                    </Button>
                    <Button
                        primary
                        disabled={this.state.disabled}
                        onClick={() => this.deletePosition()}
                        className="delete-btn"
                    >
                        <Icon name="trash alternate outline" />
                        {t("button.delete")}
                    </Button>
                    <Button
                        disabled={this.state.exportDisabled}
                        onClick={e => this.positionExportAction()}
                    >
                        <Icon name="file excel outline" />
                        {t("button.export")}
                    </Button>
                    <Button onClick={() => this.clearPosition()}>
                        <Icon name="refresh" />
                        {t("button.clearAll")}
                    </Button>
                </div>
                <PositionForm
                    positionData={this.state.position}
                    isError={this.state.inputSubmit.formError}
                    changePosition={input => this.changePosition(input)}
                />
                {successCode ? (
                    <div className="success-message list-error-message">
                        {t("message." + successCode)}
                    </div>
                ) : (
                        ""
                    )}    
                {errorCode ? (
                    <div className="error-message list-error-message">
                        {t("message." + errorCode)}
                    </div>
                ) : (
                        ""
                    )}
                <ProjectTable
                    tableStructure={this.state.tableStructure}
                    dataList={this.state.data}
                    onRowClick={val => this.onRowClick(val)}
                    unSelectRow={this.state.unSelectRow}
                    defaultSort={this.state.paramList.sortBy}
                    sortBy={val => this.sortBy(val)}
                />
                <div className="table-paging">
                    {this.state.data && this.state.data[0] ? (
                        <Pagination
                            size="tiny"
                            activePage={activePage}
                            firstItem={null}
                            lastItem={null}
                            totalPages={this.state.totalPage}
                            prevItem={{
                                disabled: this.state.activePage == 1,
                                content: <Icon name="chevron left" />,
                                icon: true
                            }}
                            nextItem={{
                                disabled: this.state.activePage == this.state.totalPage,
                                content: <Icon name="chevron right" />,
                                icon: true
                            }}
                            onPageChange={(e, { activePage }) =>
                                this.handlePaginationChange(activePage)
                            }
                        />
                    ) : (
                            ""
                        )}
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    ...state
});

const mapDispatchToProps = dispatch => ({
    getPositionList: opt => dispatch(getPositionList(opt)),
    addPosition: opt => dispatch(addPosition(opt)),
    updatePosition: opt => dispatch(updatePosition(opt)),
    exportFileAction: (url, param) => dispatch(exportFileAction(url, param)),
    deletePosition: opt => dispatch(deletePosition(opt))
});

export default compose(
    withTranslation(),
    connect(mapStateToProps, mapDispatchToProps)
)(Position);
